import { useState } from "react";
import { FaLanguage, FaRegFilePdf } from "react-icons/fa";
import { Link } from "react-router-dom";
import { API_URL, authHeader } from "../services/auth.service";
import PreviewFileComponent from "./PreviewFileComponent";
const ListDocumentation = ({
  items,
  cabecera,
  itemSelect,
  filtroTraduccion,
  files,
  defaultEmpresa,
}) => {
  // let previewHeight = window.innerWidth - 1150;
  // let previewModalHeight = previewHeight + 30;
  let controller = null;
  let signal = null;
  try {
    controller = new AbortController();
    signal = controller.signal;
  } catch (error) {
    signal = null;
  }
  const [state, setState] = useState({
    documentSelect: {},
    preview: false,
  });
  let optionsFilePond = {
    allowPdfPreview: true,
    allowMultiple: false,
    pdfPreviewHeight: window.innerWidth - 1150 + "px", //previewHeight + "px",
    pdfComponentExtraParams: "toolbar=1&page=1",
    acceptedFileTypes: ["application/pdf"],
    labelFileLoading: "Cargando",
    labelTapToCancel: "toca para cancelar",
  };
  function setColorItemPreviewFile(controlOrigen) {
    let listaElementosDigitales = document.getElementsByClassName("liItem");
    for (let index = 0; index < listaElementosDigitales.length; index++) {
      const element = listaElementosDigitales[index];
      element.style.cssText =
        "background-color: transparent; font-weight: normal;";
    }
    controlOrigen =
      controlOrigen.parentElement.childNodes[0];
    let controlLinkOrigen = null;
    switch (controlOrigen.tagName.toUpperCase()) {
      case "DIV":
        controlLinkOrigen = controlOrigen.parentElement;
        break;
      case "A":
        controlLinkOrigen = controlOrigen.parentElement.parentElement;
        break;
      case "SVG":
        controlLinkOrigen = controlOrigen.parentElement.parentElement.parentElement;
        break;
      case "PATH":
        controlLinkOrigen = controlOrigen.parentElement.parentElement.parentElement.parentElement;
        break;
      default:
        break;
    }
    controlLinkOrigen.style.cssText =
      "background-color: #EEF7E7; font-weight: bold; border: 1px solid transparent; border-radius: 10px; padding: 3px;";
  }
  const previewFile = (item, esTraduccion, e) => {
    e.preventDefault();
    setColorItemPreviewFile(e.target);

    //El primer parametro del bind pasa a ser el ultimo
    let documentSelect = item;
    optionsFilePond.server = {
      load: (source, load, error, progress, abort, headers) => {
        try {
          source = source + "&defaultEmpresa=" + defaultEmpresa;
          if (esTraduccion) {
            source = source.replace("getItemDigital/", "getItemDigitalCustom/");
          }
          fetch(source, {
            signal: signal,
            headers: authHeader(),
          })
            .then(function (response) {
              if (response.status === 200) {
                response.blob().then(function (myBlob) {
                  myBlob.name = documentSelect.DocumentoDescripcion;
                  progress(true, 0, myBlob.size);
                  load(myBlob);
                  setTimeout(function () {
                    // setStyleModalshowAddFile(true);
                  }, 100);
                });
              } else {
                // emptyFilePond();
              }
            })
            .catch(function (e) {});
        } catch (error) {
          console.log(error);
          controller.abort();
        }
      },
      process: (
        fieldName,
        file,
        metadata,
        load,
        error,
        progress,
        abort,
        transfer,
        options
      ) => {
        return false;
      },
      revert: (uniqueFileId, load, error) => {
        return false;
      },
    };

    let url = `${API_URL}/${
      esTraduccion
        ? documentSelect.DocumentoRuta.replace(
            "getItemDigital/",
            "getItemDigitalCustom/"
          )
        : documentSelect.DocumentoRuta
    }`;
    url = url.replace("digital", "guia");

    optionsFilePond.files = [
      {
        source: url,
        options: {
          type: "local",
          load: true,
        },
      },
    ];

    setState({
      documentSelect: item,
      esTraduccion: esTraduccion,
      preview: true,
      optionsFilePond: optionsFilePond,
    });
  };
  return (
    <>
      <div className="flex flex-cols grid-cols-3 text-sm">
        <div className="w-[35%]">
          <div className="flex flex-rows px-1 pb-5 pt-2 mr-2 mb-3">
            <div className="w-[33%]">
              <span className="font-bold">CÓDIGO</span>
              <span className="bg-green-600 text-white p-1 rounded-lg ml-1 font-bold px-3 py-2">
                {itemSelect.Codigo}
              </span>
            </div>
            <div className="w-[33%]">
              <span className="font-bold">LOTE</span>
              <span className="bg-green-600 text-white p-1 rounded-lg ml-1 font-bold px-3 py-2">
                {itemSelect.Lote}
              </span>
            </div>
            <div className="w-[33%]">
              <span className="font-bold">REGISTRO</span>
              <span className="bg-green-600 text-white p-1 rounded-lg ml-1 font-bold px-3 py-2">
                {itemSelect.RS}
              </span>
            </div>
          </div>
          {cabecera.map((tipo) => (
            <div key={tipo.Descripcion}>
              <div className="bg-green-600 text-white font-bold px-8 py-1 mr-2 rounded-lg ml-1 divEncabezado">
                <label>{tipo.Descripcion}</label>
              </div>
              <div>
                <ul>
                  {items.map((item) =>
                    tipo.Codigo === item.TipoCodigo ? (
                      <li
                        key={item.DocumentoDescripcion}
                        className="flex justify-between mr-2 ml-2 my-2 liItem"
                      >
                        <div
                          className="flex flex-1 items-center gap-3 cursor-pointer"
                          onClick={previewFile.bind(this, item, false)}
                        >
                          <Link className="text-red-600 text-lg p-0 m-0 ">
                            <FaRegFilePdf />
                          </Link>
                          <span className="">{item.DocumentoDescripcion}</span>
                        </div>
                        {item.TieneTraduccion &&
                        filtroTraduccion.includes(item.TipoCodigo) ? (
                          <div
                            className="w-[10%] bg-blue-200 rounded-md cursor-pointer flex justify-center"
                            onClick={previewFile.bind(this, item, true)}
                          >
                            <Link className="text-blue-600 text-2xl p-0 m-0">
                              <FaLanguage />
                            </Link>
                          </div>
                        ) : null}
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            </div>
          ))}
        </div>
        {/* <div className={`w-[65%] h-[${previewModalHeight}px]`}> */}
        <div className={`w-[65%] h-[800px]`}>
          {/* <div className={`w-[65%] h-[${previewModalHeight}px]`}> */}
          {/* <div className={`w-[65%] h-[${optionsFilePond.pdfPreviewHeight}]`}> */}
          {/* <div className={`w-[65%] h-[${optionsFilePond.pdfPreviewHeight.replace('px','') - 10}px]`}> */}
          {state.preview ? (
            <PreviewFileComponent optionsFilePond={state.optionsFilePond} />
          ) : null}
        </div>
      </div>
    </>
  );
};
export default ListDocumentation;
